import { render, staticRenderFns } from "./Toggle2FA.vue?vue&type=template&id=2c6b9820&scoped=true"
import script from "./Toggle2FA.vue?vue&type=script&lang=js"
export * from "./Toggle2FA.vue?vue&type=script&lang=js"
import style0 from "./Toggle2FA.vue?vue&type=style&index=0&id=2c6b9820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b9820",
  null
  
)

export default component.exports